import { Text } from '@noorden-insurtech/alba-design-system';

type Props = {
  /** Validation messages to display. Empty/blank entries are ignored. */
  messages: Array<string | undefined>;
  className?: string;
};

/**
 * Full-width error banner for Capital Global coverages.
 *
 * Long validation messages would break the narrow currency/percent input
 * columns, so they are surfaced here (matching the pattern used by
 * `CoverageCard` in the other products) while the inputs only keep the
 * invalid (red border) state.
 */
export function CoverageErrorBanner({ messages, className }: Props) {
  const visibleMessages = messages
    .map(message => message?.trim())
    .filter((message): message is string => Boolean(message));

  if (visibleMessages.length === 0) return null;

  return (
    <div
      role='alert'
      className={`flex flex-col gap-1 rounded-lg border border-red-200 bg-red-50 px-4 py-3 ${className ?? ''}`}
    >
      {visibleMessages.map(message => (
        <Text key={message} className='break-words text-xs text-red-600'>
          {message}
        </Text>
      ))}
    </div>
  );
}
